import { LabelCommon, LabelComposition, LabelTwoVerticalLevel } from "components/UI/labels";
import { changeNullAndEmptyStringToDefault } from "core/str_utils";

import styles from "./KatsEstmFooterSignatures.module.css";

const KEYS_WIDTH = "80px";
const VALUE_WIDTH = "600px";
const mainLabelStyle = {
	borderBottom: "1px solid black",
	textDecoration: "auto",
	width: VALUE_WIDTH,
	textAlign: "center",
	display: "table",
};

const KatsEstmFooterSignatures = ({ data }) => {
	return (
		<div className={styles.KatsEstmFooterSignatures}>
			<LabelComposition>
				<LabelCommon text="Составил" style={{ width: KEYS_WIDTH }} />
				<LabelTwoVerticalLevel
					main={changeNullAndEmptyStringToDefault(data.signatures_composer, "-")}
					second="[должность, подпись (инициалы, фамилия)]"
					style={{ mainLabel: mainLabelStyle, box: { width: VALUE_WIDTH } }}
				/>
			</LabelComposition>
			<LabelComposition>
				<LabelCommon text="Проверил" style={{ width: KEYS_WIDTH }} />
				<LabelTwoVerticalLevel
					main={changeNullAndEmptyStringToDefault(data.signatures_verifier, "-")}
					second="[должность, подпись (инициалы, фамилия)]"
					style={{ mainLabel: mainLabelStyle, box: { width: VALUE_WIDTH } }}
				/>
			</LabelComposition>
			{data?.display_properties?.signatures_developer?.show === true && (
				<LabelComposition>
					<LabelCommon text="Застройщик (технический заказчик)" style={{ width: KEYS_WIDTH }} />
					<LabelTwoVerticalLevel
						main={changeNullAndEmptyStringToDefault(data.signatures_developer, "-")}
						second="[должность, подпись (инициалы, фамилия)]"
						style={{ mainLabel: mainLabelStyle, box: { width: VALUE_WIDTH } }}
					/>
				</LabelComposition>
			)}
		</div>
	);
};

export { KatsEstmFooterSignatures };
